import React from 'react';
import { Link } from 'react-router-dom';

const ClientProjectsTab = ({ client }) => {
  return (
    <div className="mt-6">
      {/* Header - Indigo Theme */}
      <div className="bg-white shadow overflow-hidden sm:rounded-lg border-l-4 border-indigo-500">
        <div className="px-4 py-5 sm:px-6 bg-indigo-50">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-xl font-semibold text-indigo-900">Projects</h2>
              <p className="mt-2 text-sm text-indigo-700">
                Projects associated with this client
                {client.projects ? ` (${client.projects.length})` : ' (0)'}
              </p>
            </div>
            <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
              <Link
                to={`/projects/add?client=${client.id}`}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Add Project
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Table or Empty State */}
      {client.projects && Array.isArray(client.projects) && client.projects.length > 0 ? (
        <div className="mt-6 bg-white shadow overflow-hidden sm:rounded-lg border-l-4 border-indigo-100">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                        Project Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Status
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Created
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">View</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {client.projects.map((project) => (
                      <tr key={project.id || project._id}>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {project.name}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            project.status === 'Completed' ? 'bg-green-100 text-green-800' :
                            project.status === 'Active' ? 'bg-blue-100 text-blue-800' :
                            'bg-yellow-100 text-yellow-800'
                          }`}>
                            {project.status || 'Not Set'}
                          </span>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {project.created_at ? new Date(project.created_at).toLocaleDateString() : 'Not set'}
                        </td>
                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          <Link to={`/projects/${project.id}`} className="text-indigo-600 hover:text-indigo-900 font-semibold focus:outline-none focus:underline">
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center py-12 bg-white mt-6 border border-gray-200 rounded-md">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100">
            <svg
              className="h-6 w-6 text-indigo-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
              />
            </svg>
          </div>
          <h3 className="mt-4 text-sm font-medium text-gray-900">No projects</h3>
          <p className="mt-2 text-sm text-gray-500">
            This client doesn't have any projects yet.
          </p>
          <div className="mt-6">
            <Link
              to={`/projects/add?client=${client.id}`}
              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Add Project
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientProjectsTab; 